export enum ConfirmationResult {
  Confirm = 'confirm',
  Cancel = 'cancel',
}
